<template>
  <div class="faux-form">
    <select
      ref="input"
      class="select px-4 py-5 bg-transparent border-0 border-b-2 border-b-fau-blue-bright text-fau-blue-bright min-w-[200px] max-w-full w-full line-clamp-1
              focus-visible:border-2 focus-visible:border-fau-red"
      v-bind:value="dataValue"
      v-on:change="onChange"
      v-on:keydown="onKeyDownListener"
      v-on:keyup="onKeyUpListener"
      v-bind:required="question.required"
    >
      <!--Select is not working here... -->
      <!-- <option disabled :selected="true">{{ question.placeholder }}</option> -->
      <option value="" class="text-fau-gray h-[100px]" selected>{{ question.placeholder }}</option>
      <option v-for="(option, index) in question.options" v-bind:disabled="option.disabled" v-bind:value="option.choiceValue()" v-bind:key="'o' + index" class="line-clamp-1">
        {{ option.choiceLabel() }}
      </option>
    </select>
    
    

  </div>
</template>

<script>
  /*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://github.com/ditdot-dev/vue-flow-form
    https://www.ditdot.hr/en
  */

  import logic from '@ditdot-dev/vue-flow-form/src/composables/QuestionTypes/DropdownType'

  export default logic
</script>